import { Div } from "@hopper-ui/components";
import { useGetCurrentUserSuspenseQuery, useSubscriptionTier, useWrapWords } from "@workleap-ai/shared";
import { useTranslation } from "react-i18next";
import "./GreetingMessage.css";

export const GreetingMessage = () => {
    const { t } = useTranslation();
    const { data: { displayName } } = useGetCurrentUserSuspenseQuery();
    const { isPremium } = useSubscriptionTier();
    const tagline = isPremium ? `<br/>${t("tagline")}` : "";
    const { wordsWithSpan: greetingsWithSpan } = useWrapWords(`${t("greetings", { displayName })}${tagline}`);

    return (
        <Div textAlign="center">
            <Div
                fontFamily={{
                    base: "heading-xl",
                    sm: "heading-3xl"
                }}
                fontWeight={{
                    base: "heading-xl",
                    sm: "heading-3xl"
                }}
                fontSize={{
                    base: "heading-xl",
                    sm: "heading-3xl"
                }}
                color="neutral"
                className="wai-greetings"
            >
                {greetingsWithSpan}
            </Div>
        </Div>
    );
};
